import {post} from 'axios';
import Core6Component from './Core6Component';
import Core6RowAjax from './Core6RowAjax';
import Core6Utilities from './Core6Utilities';
import Core6ImageManager from "./Core6ImageManager";
import Core6OptionsLogic from "./Core6OptionsLogic";

export default class Core6ComponentDialogs {
  initialise() {
    //console.log('init Core6ComponentDialogs');

    $(document.body).on(
      'click change',
      '[data-core6-component-action]',
      Core6ComponentDialogs.adminOptionsListener,
    );

    $(document.body).on(
      'click',
      '[data-core6-save-component-options]',
      (evt) => {
        const componentId = $(evt.currentTarget).attr('data-component-id');
        const componentOptions = Core6Utilities.getJQueryElement('.changeComponentOptionsModal[data-component-id="' + componentId + '"] [data-core6-component-action]');
        const rowId = Core6Utilities.getJQueryElement('.changeComponentOptionsModal[data-component-id="'+componentId+'"]').attr('data-row-id');
        Core6OptionsLogic.saveOptions(evt, componentOptions, componentId, rowId, 0, 'component');
      },
    );

    $(document.body).on(
      'click',
      '[data-core6-save-theme-options]',
      (evt) => {
        const componentId = $(evt.currentTarget).attr('data-component-id');
        const componentOptions = Core6Utilities.getJQueryElement('.changeComponentThemeModal[data-component-id="' + componentId + '"] [data-core6-component-action]');
        const rowId = Core6Utilities.getJQueryElement('.changeComponentThemeModal[data-component-id="'+componentId+'"]').attr('data-row-id');
        Core6OptionsLogic.saveOptions(evt, componentOptions, componentId, rowId, 0, 'component');
      },
    );

    $(document.body).on(
      'click',
      '[data-core6-options-cancel]',
      (evt) => {
        $(evt.target).modal('hide');
        //console.log('Been hidden');
        setTimeout(Core6Utilities.refreshDialogs(), 0);

      },
    );
  }

  static adminOptionsListener(evt) {
    //console.log('init admin options');
    const componentId = $(this).attr('data-component-id');
    const rowId = $(this).attr('data-row-id');
    const action = $(this).attr('data-core6-component-action');
    let consumed = true;

    //console.log($('<div>').append($(this).clone()).html());

    //console.log(`${componentId} - ${action}`);

    switch (action) {
      case 'saveHtml':
        if (evt.type === 'click') {
          //console.log('Save html here...');
          const value = document.querySelector(`#editor_${componentId}`).value;

          document.getElementById(`editor_savestatus_unsaved_${componentId}`).style.display = 'none';
          document.getElementById(`editor_savestatus_saved_${componentId}`).style.display = 'inline-block';

          Core6Component.changeComponentAttribute(componentId, 'html', value, rowId);
        }
        break;
      case 'changeComponentTheme':
        if (evt.type === 'click') {
          //console.log('Change Component Theme Clicked');
          const value = $(this).attr('data-core6-component-value');
          $(this).siblings().removeClass('selected');
          $(this).addClass('selected');
          //Core6Component.changeComponentAttribute(componentId, 'theme', value, rowId);
        }
        break;
      case 'changeComponentColour':
        if (evt.type === 'click') {
          //console.log('Change Component Colour Clicked');
          const param = $(this).attr('data-core6-component-param');
          const value = $(this).attr('data-core6-component-value');
          $(this).siblings().removeClass('selected');
          $(this).addClass('selected');
          //Core6Component.changeComponentAttribute(componentId, param, value, rowId);
        }
        break;
      case 'cloneComponent':
        //console.log(`EVT TYPE: ${evt.type}`);
        if (evt.type === 'click') {
          //console.log('Clone Component Clicked');
          Core6Component.cloneComponent(componentId, rowId);
        }
        break;
      case 'deleteComponent':
        if (evt.type === 'click') {
          //console.log('Delete Component Clicked');
          Core6Component.deleteComponent(componentId);
        }
        break;
      case 'selectImage':
        if (evt.type === 'click') {
          //console.log('Update Component Param Clicked');
          //console.log(componentId);
          const mediaPickerModal = Core6Utilities.getJQueryElement('.mediaPickerModal.in');

          //componentId = mediaPickerModal.find('[data-core6-component-action=selectImage]').attr('data-component-id');
          let imageValue = $(this).attr('data-value');
          //rowId = mediaPickerModal.find('[data-core6-component-action=selectImage]').attr('data-row-id');
          mediaPickerModal.modal('hide');

          //console.log(imageValue);

          if (imageValue === undefined) {
            imageValue = '';
          }

          if (componentId === 0 || componentId === '0') {
            //console.log('ROW!!!');
            $(`[data-core6-component-action="showMediaPicker"][data-row-id="${rowId}"]`).attr('data-current_image', imageValue);
            Core6RowAjax.changeBlockAttribute(rowId, $(this).attr('data-param'), imageValue, true);
          } else {
            //console.log('COMPONENT!!!');
            Core6Component.changeComponentAttribute(componentId, $(this).attr('data-param'), imageValue, rowId, true);
          }
        }
        break;
      case 'updateImageMediaButtonValue':
        //console.log('Update Image Media Button Value Clicked');
        Core6ImageManager.updateImageMediaButtonValue($(this).attr('data-param'), $(this).attr('data-value'), $(this)); // TODO!!!!!!!!!!!!!!!!!!!!!!!
        break;
      case 'changeComponentAttribute':
        const val = $(this).val();
        const param = $(this).attr('name');

        if (param === 'feature_url_type' || param === 'feature_url_download' || param === 'feature_url_page') {
          Core6Component.featureUrlLogic(componentId, rowId, false, param, val);
        }

        if (param === 'button_url_type' || param === 'button_url_download' || param === 'button_url_page') {
          Core6Component.buttonUrlLogic(componentId, rowId, false, param, val);
        }

        //Core6Component.changeComponentAttribute(componentId, $(this).attr('name'), val, rowId);
        //console.log(`change component attrib: c_id-${componentId} name-${$(this).attr('name')} val-${$(this).val()} row_id-${rowId}`);
        break;
    }

    if (consumed == true) {
      evt.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6ComponentDialogs.js